import styled from "styled-components";
import { ButtonStyles } from "../../types/styles";
import { Icon } from "../.";
import { ArrowRightSolid } from "../../assets/icons";

const StyledButton = styled.button<{
  styles: ButtonStyles;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  background-color: ${({ styles }) => styles.OverallBookButtonColour};
  color: ${({ styles }) => styles.OverallBookButtonFontColour};
  border-radius: ${({ styles }) => `${styles.OverallGeneralBorderRadius}px`};
  border: none;
  font-size: 15px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.25s;

  &:disabled {
    opacity: 0.4;
  }

  &:focus,
  &:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }
`;

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: string;
  rightArrowIcon?: boolean;
  styles: ButtonStyles;
  dataId?: string;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  rightArrowIcon,
  styles,
  ...props
}) => {
  return (
    <StyledButton
      {...props}
      type={props.type ? props.type : "button"}
      styles={styles}
      data-id={props.dataId}
    >
      {children}{" "}
      {rightArrowIcon && (
        <IconContainer>
          <Icon
            icon={ArrowRightSolid}
            color={styles.OverallBookButtonFontColour}
          />
        </IconContainer>
      )}
    </StyledButton>
  );
};

export default Button;
